"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GET_DEVICES_QUERY = "\n  query Devices {\n    user {\n      devices {\n        deviceId\n        model\n        lastUsed\n        registeredOn\n        name\n        active\n        family\n      }\n    }\n  }\n";
exports.default = GET_DEVICES_QUERY;
//# sourceMappingURL=getDevices.js.map